var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "pc-ideabook-recommendation-modal",
      attrs: {
        width: "500",
        height: "auto",
        name: "pc-ideabook-recommendation-modal",
        "data-html2canvas-ignore": "true",
        adaptive: true,
        scrollable: false
      }
    },
    [
      _c("div", { staticClass: "pc-ideabook-recommendation-modal-container" }, [
        _c(
          "button",
          {
            staticClass:
              "ideabook-recommendation-modal-button-close btn button-full",
            attrs: { type: "button" },
            on: { click: _vm.closeModal }
          },
          [
            _c("span", {
              staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
              attrs: { "aria-label": "Close modal" }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pc-ideabook-recommendation-modal-wrapper" }, [
          _c("div", { staticClass: "ideabook-recommendations-heading" }, [
            _c("h5", { staticClass: "primary-heading" }, [
              _vm._v(
                _vm._s(
                  _vm.$resourceString["myBasket.IdeaBook.Recommendations.Title"]
                ) + ":"
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "primary-description" }, [
              _vm._v(
                _vm._s(
                  _vm.$resourceString["myBasket.IdeaBook.Label.IdeaBook"]
                ) +
                  " " +
                  _vm._s(_vm.basketItems.LatestIdeaBook.IdeabookPublicationYear)
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "primary-description" }, [
              _vm._v(_vm._s(_vm.basketItems.LatestIdeaBook.IdeabookName))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ideabook-recommendations-details" }, [
            _c("div", { staticClass: "ideabook-recommendations-coverimage" }, [
              _c("img", {
                attrs: {
                  src: _vm.basketItems.LatestIdeaBook.IdeabookCoverImage.replace(
                    "~",
                    ""
                  ),
                  alt: ""
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ideabook-recommendations-buttons" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary next-btn",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.continueToCheckOut(true, false)
                  }
                }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$resourceString["checkout.Ideabook.Modal.AddToCart"]
                    ) +
                    "\n                "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-white border border-dark next-btn",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.continueToCheckOut(false, true)
                  }
                }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$resourceString["checkout.Ideabook.Modal.Proceed"]
                    ) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }